import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { Archive } from "src/app/modules/bootstrap/rocket-ui/backend/models/archive";
import { PaginatedResult } from "src/app/support/paginated-result";

import { environment } from "src/environments/environment";

@Injectable()
export class ArchiveBackend {
  private readonly http = inject(HttpClient);

  loadAll(): Observable<PaginatedResult<Archive>> {
    return this.http.get<PaginatedResult<Archive>>(
      `${environment.snoots.api.diagnostic}/archives`
    );
  }

  loadByTenant(tenant: string): Observable<PaginatedResult<Archive>> {
    return this.http.get<PaginatedResult<Archive>>(
      `${environment.snoots.api.diagnostic}/archives`,
      {
        params: {
          tenant
        }
      }
    );
  }
}
